import type { LocationQueryValue, LocationQueryValueRaw } from "#vue-router";

export const queryValueToArrayOfIds = (queryValue: LocationQueryValueRaw | LocationQueryValue[]) => {
	if (queryValue) {
		const stringIds = Array.isArray(queryValue) ? queryValue as string[] : [queryValue];

		return stringIds.map(stringId => +stringId);
	} else {
		return [];
	}
};
